// Function loadJudgeItemBlock loads the JudgeItemBlock class by dynamically importing the js on demand if needed

export function loadJudgeItemBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-judge-item-block-chunk" */ '../widgets/judgeItemBlock').then(wg => {

		const { JudgeItemBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="JudgeItemBlock"]');

		if(!$wg) {
			// console.info('JudgeItemBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="JudgeItemBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new JudgeItemBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new JudgeItemBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the JudgeItemBlock widget');

}
